export enum FilterCategory {
    Country = 1,
    Status = 2,
    Score = 3,
    UserRegister = 4,
    SmileboxOrders = 5,
    TreatmentPlanProcessing = 6,
    StraightboxOrders = 7,
    AdditionalFilters = 8
} 